export default __webpack_public_path__ + "static/media/android -logo.6d6bfba5.svg";